import styled from "styled-components";

export const _ProductLineImageRoot = styled("div")<{ $size: number }>(
  ({ $size }) => {
    return {
      position: "relative",
      width: $size,
      height: $size,
      borderRadius: 4,
      overflow: "hidden",
    };
  }
);
